/**
 * Join class names through a CSS-Modules map, falling back to the raw name
 * when the map has no entry. Mirrors DevLink's own `utils.cx`, which matters
 * for two reasons:
 *
 *   - Pre-sync, `@devlink/styles` resolves to the local stand-in module, which
 *     only defines the handful of layout classes this app uses.
 *   - Post-sync it resolves to Webflow's `classes.module.css`. Any class the
 *     Designer no longer exports degrades to an unstyled global name instead of
 *     emitting `class="undefined"`.
 */
export function cls(
  styles: Record<string, string>,
  ...names: Array<string | false | null | undefined>
): string {
  return names
    .filter((n): n is string => Boolean(n))
    .map((n) => styles[n] ?? n)
    .join(" ");
}
